// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotlight.css
// module id = 4187
// module chunks = 0